module.exports = __webpack_public_path__ + "img/multiple-comands.8e3b77b5.svg";